import UserTask from "./UserTask"

function UserTasks({username, tasks, responses, selectedTasks}) {
  return (
    <>

    {tasks.map((task)=>{
      if(selectedTasks.includes(task._id)){
      return (
        <UserTask key={task._id} task={task} responses={responses} username={username} />
      
      )
      }
    })}    
    </>
  )
}

export default UserTasks